import StaticContentPage from './StaticContentPage';

export default function ShippingPolicyPage() {
  return <StaticContentPage slug="shipping" fallbackTitle="Shipping Policy" />;
}

